const INVISIBLE_FORMAT_CHARACTERS =
  // eslint-disable-next-line no-misleading-character-class
  /[\u00ad\u034f\u061c\u115f\u1160\u17b4\u17b5\u180e\u200b-\u200f\u202a-\u202e\u2060-\u206f\ufeff]/g;
const UNICODE_WHITESPACE = /[\s\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000]+/g;

function decodeUrlSlugValue(value: string): string {
  try {
    return decodeURI(value);
  } catch {
    return value;
  }
}

export function normalizeUrlSlug(value: string | null | undefined): string {
  return decodeUrlSlugValue(value || '')
    .normalize('NFKC')
    .replace(INVISIBLE_FORMAT_CHARACTERS, '')
    .trim()
    .replace(UNICODE_WHITESPACE, '-')
    .replace(/-+/g, '-');
}

export function toUrlSlug(value: string | null | undefined): string {
  return normalizeUrlSlug(value).toLowerCase();
}
